import React from 'react'
import npop from '../image/npop.jpg'
import { NavLink } from 'react-router-dom'

const Varietydetails10 = () => {
  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden h-screen">
      <div>
      <NavLink to="https://www.youtube.com/watch?v=N0hNmbzIK5s"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 p-5" href="https://www.youtube.com/watch?v=N0hNmbzIK5s">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={npop} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          NPOP
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>  September 9, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>1
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
      <hr class="border-purple-500 mt-5"></hr>

<div>
  <div className='flex justify-center'>
     <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>On September 9, 2023 KST, V will make a guest appearance on the music show 'NPOP,'' where he will perform 3 songs from his new solo album, 'Layover.' Showtime: 12am PT/3am ET.  The episode will air again on September 13, 2023.</p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>'NPO' is the first monthly K-Pop chart show in Korea newly launched by Naver and Playlist created by artists and fans together.</p>
  </div>
</div>
      </div>
    </div>
  )
}

export default Varietydetails10
